const YzlLogin = async (code, state, vm) => {
	const yzlRes = await vm.$zkHttp.user$wechatCallback({
		code,
		state
	});
	console.log("yzlRes => ", yzlRes);
	// 微信返回给云端
	// access_token:"90_rF6esfppb4uv-Lb85QiwQ2-LABa3-KV5WhXgxvdOkAnnTpjYsR9zFz0Q2VoacLLmJnbjzkzg_wjFg1KWdU9nvTwtuHTGFwcYvtA7aiKmKiM"
	// expires_in:7200
	// openid:"oByXP68HkbIbihW0RVo4_QiJ8a5g"
	// refresh_token:"90_52MZPFmwYE6SEY1rC5J80T43FwfGGX8GEUWzKgFy-pTLCeMMhv8-EZJkcfLPVzQDfOA3u6rXLaoxiSgcDgkjdnTT9CL15EfsjtDQAGfC5ng"
	// scope:"snsapi_login"
	// unionid:"oISLP62-GxKGyQpqcTAnz-RJtoQw"
	// 云端返回给前端
	// userinfo:{
	// avatar:"https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEK3SEJdia9xCafhghFpoEOCRFw6yKdutDoOmDnMrU6vKQicpcTKpRNConMzfDQwSh1738DdicMRhGBlJJicQ1IgyVOf1sfz1cB4eU4jrPZIzwlGZA/132"
	// createtime:1742007978
	// expires_in:2592000
	// expiretime:1744599978
	// id:7
	// mobile:""
	// nickname:"Kui"
	// score:0
	// token:"99544a38-b89f-4f79-bbdc-162f8406d4ef"
	// user_id:7
	// username:"Kui"
	if (yzlRes && yzlRes.userinfo && yzlRes.userinfo.id) {
		vm.$store.commit("auth/setLoginInfo", {
			...yzlRes.userinfo,
		});
		vm.$message({
			message: "登录成功",
			type: "success", // message type: success/warning/info/error
		});
	} else {
		vm.$message({
			message: "登录失败",
			type: "error", // message type: success/warning/info/error
		});
	}
	const path = vm.$route.path;
	console.log("path => ", path);
	const timestamp = Date.now();
	vm.$router.replace({
		path: `${path}`,
		query: {
			t: timestamp
		}
	})

}

export default YzlLogin;